import React from 'react';
import { deleteRoundingRule, getRoundingRule, getRoundingRuleById } from './actions/RoundingRuleActions';
import Alert from 'react-s-alert';
import classNames from 'classnames';
import { connect } from 'react-redux';
import PaginatorCustom from './../../../../components/paginationCustom';
import RoundingRuleModal from './rounding-rule-modal';
import RaisedButton from 'material-ui/RaisedButton';
import Sorting from '../../../../components/SortingCustom';
import { Field, reduxForm, reset } from 'redux-form';
import { renderTextField } from '../../../../components/reduxFields';
import GlobalVariables, { resetFiltersAndSorting, alertConfirmation } from '../../../../actions/utilAction';

class RoundingRule extends React.Component {
  constructor(props) {
    super(props);
    this.state = ({
      // roundingRuleData: [],
      roundingRuleObj: {},
      open: false,
      // master_data: [],
      // ruleName: null,
    });
    this.filter = {
      sort_Order: 'desc',
      sort_Column: 'id',
      searchText: '',
    };
    this.renderRoundingRules = this.renderRoundingRules.bind(this);
    this.handleSearchRoundingRule = this.handleSearchRoundingRule.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleResetButton = this.handleResetButton.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
  };

  componentWillMount() {
    this.loadData();
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.roundingRuleAdded && this.props.roundingRuleAdded !== nextProps.roundingRuleAdded) {
      this.loadData();
    }
    if (nextProps.roundingRuleDeleted && this.props.roundingRuleDeleted !== nextProps.roundingRuleDeleted) {
      this.loadData();
    }
  };

  loadData(pageNumber) {
    let searchObj = {
      sort_fields: this.filter.sort_Column ? this.filter.sort_Column : '-id',
      sort_order: this.filter.sort_Order ? this.filter.sort_Order : 'desc',
      filters: {
        ruleName: this.filter.searchText ? this.filter.searchText : '',
      },
      pageNumber: pageNumber ? pageNumber : 1,
      pageSize: GlobalVariables.PageSize,
    };
    this.props.getRoundingRule(searchObj);
  }

  handleOpen = () => {
    Alert.closeAll();
    this.setState({ open: true, roundingRuleObj: null });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  handleSearchRoundingRule(event) {
    this.filter.searchText = event.ruleName ? event.ruleName : '';
    this.loadData();
    // this.setState({
    //   ruleName: event.ruleName ? event.ruleName : '',
    // }, () => {
    //   this.loadData();
    // });
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_Order = col_order;

      this.loadData();
    }
  }

  handleSearchChange(event) {
    if (event.target.value.length > 2) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.setState({
        ruleName: event.target.value ? event.target.value : '',
      });
      this.loadData();
    }
  }

  componentWillUnmount() {
    Alert.closeAll();
  }

  handleResetButton() {
    Alert.closeAll();
    this.props.dispatch(reset('RoundingRuleForm'));
    resetFiltersAndSorting(this.filter, 'id', false);
    this.loadData();
  }

  // handleReset = () => {
  //   this.setState({ id: null });
  //   this.refs.ruleName.setState({ value: '' });
  //   this.loadData();
  // }

  handleEditClick = (event, roundingRuleObj) => {
    Alert.closeAll();
    this.setState({ open: true, roundingRuleObj: roundingRuleObj });
    if (roundingRuleObj.id) {
      this.props.getRoundingRuleById(roundingRuleObj.id);
    }
  };

  handleAlertClick = (event, id) => {
    this.props.deleteRoundingRule(id);
    Alert.closeAll();
  };

  handleDeleteClick = (event, roundingRuleObj) => {
    alertConfirmation('Are you sure you want to delete this rounding rule?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: roundingRuleObj.id,
      },
    });
  };

  renderRoundingRules() {
    if (this.props.roundingRuleData && this.props.roundingRuleData.data && this.props.roundingRuleData.data.length) {
      return this.props.roundingRuleData.data.map((obj, index) => {
        return (
          <tr key={index}>
            <td>{obj.ruleName}</td>
            {this.props.updatePermission || this.props.deletePermission ?
              <td>
                {
                  this.props.updatePermission ?
                    <button onClick={(e) => this.handleEditClick(e, obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                    : null
                }
                {
                  this.props.deletePermission ?
                    <button onClick={(e) => this.handleDeleteClick(e, obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                    : null
                }
              </td>
              : null
            }
          </tr>
        );
      });
    } else {
      return (
        <tr><td className="text-center no-record">No record found.</td></tr>
      );
    }
  }

  render() {
    const { handleSubmit } = this.props;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
      'suptable': true,
    });
    return (
      <div>
        <h2 className="page_title">Rounding Rule</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="modalwindow">
              <div className="row">
                <div className="col-sm-5">
                  {this.props.addPermission ?
                    <RaisedButton label="Add Rounding Rule" primary={true} onTouchTap={this.handleOpen} />
                    : null
                  }
                </div>
                <div className="col-sm-7">
                  <div className="row end-flex">
                    <div className="col-sm-6 mtm-27">
                      <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchRoundingRule)}>
                        <Field
                          name="RoundingRule"
                          floatingLabelText="Search"
                          maxLength='15'
                          onChange={this.handleSearchChange}
                          component={renderTextField}
                        />
                      </form>
                    </div>
                    <div className="reset-btn col-sm-3 btn_rt">
                      <RaisedButton onTouchTap={this.handleResetButton} className="grey_btn">Reset</RaisedButton>
                    </div>
                  </div>
                </div>
              </div>
              {this.state.open ? <RoundingRuleModal roundingRuleObj={this.state.roundingRuleObj} closeDialog={this.handleClose} /> : null}
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="table-responsive mt-15">
                  {this.props.roundingRuleData && this.props.roundingRuleData.data ? this.props.roundingRuleData.data.length ?
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="70%"><Sorting setSortColumn={this.setSortColumn} columnName='ruleName' displayName='Name' /></th>
                          {this.props.updatePermission || this.props.deletePermission ?
                            <th width="30%">Actions</th>
                            : null
                          }
                        </tr>
                      </thead>
                      <tbody>
                        {this.renderRoundingRules()}
                      </tbody>
                    </table>
                    :
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="70%">Name</th>
                          {this.props.updatePermission || this.props.deletePermission ?
                            <th width="30%">Actions</th>
                            : null
                          }
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colSpan="2">
                            <div className="familydl text-center no-record">No record found.</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    : null}

                  {this.props.roundingRuleData && this.props.roundingRuleData.data && this.props.roundingRuleData.data.length > 0 ?
                    <PaginatorCustom data={this.props.roundingRuleData.meta} handlePageChange={(pageNumber) => this.loadData(pageNumber)} />
                    : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

RoundingRule = reduxForm({
  form: 'RoundingRuleForm',
})(RoundingRule);

function mapStateToProps(state) {
  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'MASTERS');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'MASTERS_ROUNDINGRULES_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }
  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_ROUNDINGRULES_LIST_ADD')[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_ROUNDINGRULES_LIST_UPDATE')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_ROUNDINGRULES_LIST_DELETE')[0].permission : false;

  // End For Role Permission

  return {
    roundingRuleData: state.rounding_rule.get_rounding_rule,
    roundingRuleDeleted: state.rounding_rule.rounding_rule_deleted,
    roundingRuleAdded: state.rounding_rule.rounding_rule_added,
    addPermission: addPermission,
    updatePermission: updatePermission,
    deletePermission: deletePermission,
  };
}

export default connect(mapStateToProps, { getRoundingRule, deleteRoundingRule, getRoundingRuleById })(RoundingRule);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/rounding-rule/rounding-rule.js